import type { CalculatorDescription } from '../../../lib/calculators/calculator-description';
import { CalculatorId } from '../../../lib/calculators/calculator-config';

export const lineGraphDescription: CalculatorDescription = {
  id: CalculatorId.LineChart,
  title: 'Line Graph Maker',
  metaTitle: 'Online Line Graph Maker - Create Line Charts',
  description: 'Create professional line graphs to visualize trends and patterns over time or sequences. Perfect for showing continuous data and temporal relationships.',
  metaDescription: 'Make professional line graphs online. Visualize trends and patterns with our free line graph generator. Perfect for time series data and continuous relationships.',
  howTo: {
    title: 'How to Create a Line Graph',
    steps: [
      'Enter your data directly into the table or upload a CSV file',
      'Use the "X-axis column" control to select which column to use for the horizontal axis',
      'Select one or more numeric columns using the "Y-axis columns" control for your data series',
      'Add a title to your graph using the "Chart title" field',
      'Customize the appearance with the "Appearance" tab options including area fills, opacity, and marker size'
    ],
    graphic: {
      description: 'An echarts line graph with multiple series, markers, and optional area fills'
    }
  },
  examples: [
    {
      title: 'Time Series Analysis',
      description: 'Track changes over time',
      dataDescription: 'Monthly temperature and rainfall data over a year',
      insights: [
        'Identify seasonal patterns',
        'Spot trends and cycles',
        'Compare multiple variables',
        'Detect anomalies'
      ]
    },
    {
      title: 'Performance Tracking',
      description: 'Monitor progress and growth',
      dataDescription: 'Sales or performance metrics over time',
      insights: [
        'Track growth rates',
        'Compare performance periods',
        'Visualize targets',
        'Analyze trends'
      ]
    }
  ],
  relatedCalculators: [
    CalculatorId.ScatterChart,
    CalculatorId.XYPlot,
    CalculatorId.ColumnChart,
    CalculatorId.BarGraph
  ]
}; 